"use client";

import { SingleProduct } from "@/__generated__/graphql";
import ShareIcon from "@/app/_components/Icons/ShareIcon";
import { Close, Instagram, WhatsApp } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";

import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import { useSnackbar } from "notistack";
import { webEnv } from "@/environment/environment";

// function LinkedInIcon() {
//   return (
//     <>
//       <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.31">
//         <path
//           fill="#0a66c2"
//           fillRule="evenodd"
//           d="M27.75,0H95.13a27.83,27.83,0,0,1,27.75,27.75V94.57a27.83,27.83,0,0,1-27.75,27.74H27.75A27.83,27.83,0,0,1,0,94.57V27.75A27.83,27.83,0,0,1,27.75,0Z"
//         />
//         <path
//           fill="#fff"
//           fillRule="evenodd"
//           d="M49.19,47.41H64.72v8h.22c2.17-3.88,7.45-8,15.34-8,16.39,0,19.42,10.2,19.42,23.47V98.94H83.51V74c0-5.71-.12-13.06-8.42-13.06s-9.72,6.21-9.72,12.65v25.4H49.19V47.41ZM40,31.79a8.42,8.42,0,1,1-8.42-8.42A8.43,8.43,0,0,1,40,31.79ZM23.18,47.41H40V98.94H23.18V47.41Z"
//         />
//       </svg>
//     </>
//   );
// }
// function XIcon() {
//   return (
//     <>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         shapeRendering="geometricPrecision"
//         textRendering="geometricPrecision"
//         imageRendering="optimizeQuality"
//         fillRule="evenodd"
//         clipRule="evenodd"
//         viewBox="0 0 512 462.799"
//       >
//         <path
//           fillRule="nonzero"
//           className="svg-icon"
//           d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"
//         />
//       </svg>
//     </>
//   );
// }
// function TelegramIcon() {
//   return (
//     <>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         shapeRendering="geometricPrecision"
//         textRendering="geometricPrecision"
//         imageRendering="optimizeQuality"
//         fillRule="evenodd"
//         clipRule="evenodd"
//         viewBox="0 0 512 512"
//       >
//         <defs>
//           <linearGradient id="prefix__a" gradientUnits="userSpaceOnUse" x1="256" y1="3.84" x2="256" y2="512">
//             <stop offset="0" stopColor="#2AABEE" />
//             <stop offset="1" stopColor="#229ED9" />
//           </linearGradient>
//         </defs>
//         <circle fill="url(#prefix__a)" cx="256" cy="256" r="256" />
//         <path
//           fill="#fff"
//           d="M115.88 253.3c74.63-32.52 124.39-53.95 149.29-64.31 71.1-29.57 85.87-34.71 95.5-34.88 2.12-.03 6.85.49 9.92 2.98 2.59 2.1 3.3 4.94 3.64 6.93.34 2 .77 6.53.43 10.08-3.85 40.48-20.52 138.71-29 184.05-3.59 19.19-10.66 25.62-17.5 26.25-14.86 1.37-26.15-9.83-40.55-19.27-22.53-14.76-35.26-23.96-57.13-38.37-25.28-16.66-8.89-25.81 5.51-40.77 3.77-3.92 69.27-63.5 70.54-68.9.16-.68.31-3.2-1.19-4.53s-3.71-.87-5.3-.51c-2.26.51-38.25 24.3-107.98 71.37-10.22 7.02-19.48 10.43-27.77 10.26-9.14-.2-26.72-5.17-39.79-9.42-16.03-5.21-28.77-7.97-27.66-16.82.57-4.61 6.92-9.32 19.04-14.14z"
//         />
//       </svg>
//     </>
//   );
// }
// function WhatsAppIcon() {
//   return (
//     <>
//       <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
//         <path
//           fill="#25d366"
//           fillRule="evenodd"
//           d="M205,35.05A118.61,118.61,0,0,0,120.46,0C54.6,0,1,53.61,1,119.51a119.5,119.5,0,0,0,16,59.74L0,241.19l63.36-16.63a119.43,119.43,0,0,0,57.08,14.57h0A119.54,119.54,0,0,0,205,35.07v0ZM120.5,219A99.18,99.18,0,0,1,69.91,205.1l-3.64-2.17-37.6,9.85,10-36.65-2.35-3.76A99.37,99.37,0,0,1,190.79,49.27,99.43,99.43,0,0,1,120.49,219ZM175,144.54c-3-1.51-17.67-8.71-20.39-9.71s-4.72-1.51-6.75,1.51-7.72,9.71-9.46,11.72-3.49,2.27-6.45.76-12.63-4.66-24-14.84A91.1,91.1,0,0,1,91.25,113.3c-1.75-3-.19-4.61,1.33-6.07s3-3.48,4.47-5.23a19.65,19.65,0,0,0,3-5,5.51,5.51,0,0,0-.24-5.23C99,90.27,93,75.57,90.6,69.58s-4.89-5-6.73-5.14-3.73-.09-5.7-.09a11,11,0,0,0-8,3.73C67.48,71.05,59.75,78.3,59.75,93s10.69,28.88,12.19,30.9S93,156.07,123,169c7.12,3.06,12.68,4.9,17,6.32a41.18,41.18,0,0,0,18.8,1.17c5.74-.84,17.66-7.21,20.17-14.18s2.5-13,1.75-14.19-2.69-2.06-5.7-3.59l0,0Z"
//         />
//       </svg>
//     </>
//   );
// }
// function FacebookIcon() {
//   return (
//     <>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         shapeRendering="geometricPrecision"
//         textRendering="geometricPrecision"
//         imageRendering="optimizeQuality"
//         fillRule="evenodd"
//         clipRule="evenodd"
//         viewBox="0 0 509 509"
//       >
//         <g fillRule="nonzero">
//           <path
//             fill="#0866FF"
//             d="M509 254.5C509 113.94 395.06 0 254.5 0S0 113.94 0 254.5C0 373.86 82.17 474 193.02 501.51V332.27h-52.48V254.5h52.48v-33.51c0-86.63 39.2-126.78 124.24-126.78 16.13 0 43.95 3.17 55.33 6.33v70.5c-6.01-.63-16.44-.95-29.4-.95-41.73 0-57.86 15.81-57.86 56.91v27.5h83.13l-14.28 77.77h-68.85v174.87C411.35 491.92 509 384.62 509 254.5z"
//           />
//           <path
//             fill="#fff"
//             d="M354.18 332.27l14.28-77.77h-83.13V227c0-41.1 16.13-56.91 57.86-56.91 12.96 0 23.39.32 29.4.95v-70.5c-11.38-3.16-39.2-6.33-55.33-6.33-85.04 0-124.24 40.16-124.24 126.78v33.51h-52.48v77.77h52.48v169.24c19.69 4.88 40.28 7.49 61.48 7.49 10.44 0 20.72-.64 30.83-1.86V332.27h68.85z"
//           />
//         </g>
//       </svg>
//     </>
//   );
// }
type Props = {
  product: SingleProduct;
};
export default function ShareProduct({ product }: Props) {
  const [open, setOpen] = React.useState(false);
  const [currentUrl, setCurrentUrl] = useState(`${webEnv.siteUrl}products/${product.code}/${product.title.replaceAll(" ", "-")}`);
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        enqueueSnackbar({ message: "آدرس کپی شد", variant: "default" });
      })
      .catch(() => {
        console.log("Failed to copy");
      });
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const socialIcons = [
    { component: EmailShareButton, icon: <EmailIcon fontSize="large" sx={{ color: "grey.700" }} />, label: "Email" },
    { component: TelegramShareButton, icon: <TelegramIcon fontSize="large" sx={{ color: "#2AABEE" }} />, label: "Telegram" },
    { component: WhatsappShareButton, icon: <WhatsAppIcon fontSize="large" sx={{ color: "#25d366" }} />, label: "Whatsapp" },
    { component: LinkedinShareButton, icon: <LinkedInIcon fontSize="large" sx={{ color: "#0a66c2" }} />, label: "LinkedIn" },
    { component: FacebookShareButton, icon: <FacebookIcon fontSize="large" sx={{ color: "#0866FF" }} />, label: "Facebook" },
    { component: TwitterShareButton, icon: <XIcon fontSize="large" sx={{ color: "grey.700" }} />, label: "X" },
    // { component: RedditShareButton, icon: <RedditIcon />, label: "Reddit" },
  ];

  return (
    <>
      <IconButton aria-label="Share Button" onClick={handleClickOpen} sx={{ backgroundColor: "grey.50" }}>
        <ShareIcon />
      </IconButton>
      <Dialog
        PaperProps={{
          sx: { borderRadius: 3 },
        }}
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography variant="h5">اشتراک گذاری</Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Stack spacing={2}>
              <Stack direction={"row"} alignItems={"center"} justifyContent={"start"} spacing={1} useFlexGap flexWrap={"wrap"}>
                {socialIcons.map((social, index) => {
                  const ShareButtonComponent = social.component;
                  return (
                    <ShareButtonComponent key={index} url={currentUrl}>
                      <IconButton size="large">{social.icon}</IconButton>
                    </ShareButtonComponent>
                  );
                })}
              </Stack>
              <Stack>
                <Button
                  variant="contained"
                  sx={{ borderRadius: 3 }}
                  onClick={handleCopyLink}
                  disableElevation
                  size="large"
                  startIcon={<ContentCopyIcon />}
                >
                  کپی کردن آدرس
                </Button>
              </Stack>
            </Stack>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
